import React from "react";
import NavButton from "../components/NavButton";
import "../styles/containers/Navbar.css";
import PropTypes from "prop-types";

const Navbar = (props) => {
  const parseButtons = () => {
    let keyCounter = -1;
    const allButtons = props.buttons.map((button) => {
      keyCounter += 1;
      return (
        <li key={keyCounter}>
          <NavButton label={button.label} redirect={button.redirect} />
        </li>
      );
    });
    return allButtons;
  };
  const buttonList = parseButtons();

  return <ul>{buttonList}</ul>;
};

Navbar.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      redirect: PropTypes.string.isRequired,
    })
  ),
};

export default Navbar;
